import React from "react";
import { Modal } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import useMediaQuery from "../../../Hooks/useMediaQuery";

export default function CreateProfileModal({
  show,
  handleClose,
  postProfile,
  Validaciones,
  genders,
  onChangeSelect,
  departmentList,
  municipalitiesList,
}) {
  const isMobile = useMediaQuery("(max-width: 576px)");
  return (
    <Modal
      dialogClassName={isMobile ? "" : "w-50"}
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>
          {" "}
          <div className="form__title text-center">Crear Perfil</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form form--white ">
          <Formik
            initialValues={{
              names: "",
              lastnames: "",
              birthdate: "1989-01-02",
              cedula: "",
              genderId: "",
              aboutme: "",
              profession: "",
              municipalityId: "",
              deparmentId: "",
              address: "",
            }}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              postProfile(values);
              setSubmitting(false);
            }}
            validationSchema={Validaciones}
          >
            {({ errors, touched, isSubmitting, values, setValues }) => (
              <Form>
                <div className="div__wrapper">
                  <section className="row">
                    <div className="col-12 col-md-6 col-lg-6">
                      <label htmlFor="names">Nombres</label>
                      <Field
                        type="text"
                        name="names"
                        id="names"
                        required
                      ></Field>
                      {errors.names && touched.names && (
                        <span className="form__validation form__validation--error">
                          {errors.names}
                        </span>
                      )}
                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                      <label htmlFor="lastnames">Apellidos</label>
                      <Field
                        type="text"
                        name="lastnames"
                        id="lastnames"
                        required
                      ></Field>
                      {errors.lastnames && touched.lastnames && (
                        <span className="form__validation form__validation--error">
                          {errors.lastnames}
                        </span>
                      )}
                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                      <label htmlFor="gender">Género</label>
                      <Field as="select" name="genderId" id="genderId" required>
                        <option value="" disabled hidden>
                          Elija un género
                        </option>

                        {genders.map((elm, i) => (
                          <option key={i} value={elm.genderId}>
                            {elm.description}
                          </option>
                        ))}
                      </Field>
                      {errors.genderId && touched.genderId && (
                        <span className="form__validation form__validation--error">
                          {errors.genderId}
                        </span>
                      )}
                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                      <label htmlFor="birthdate">Fecha de Nacimiento</label>
                      <br />
                      <Field
                        type="date"
                        name="birthdate"
                        id="birthdate"
                        className="form-control"
                        required
                      ></Field>
                      {errors.birthdate && touched.birthdate && (
                        <span className="form__validation form__validation--error">
                          {errors.birthdate}
                        </span>
                      )}
                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                      <label> Número de cédula</label>
                      <Field
                        type="text"
                        name="cedula"
                        placeholder="0000000000000M"
                      />
                      {errors.cedula && touched.cedula && (
                        <span className="form__validation form__validation--error">
                          {errors.cedula}
                        </span>
                      )}
                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                      <label>Dirección</label>
                      <Field type="text" name="address" />
                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                      <label htmlFor="departmentId">Departamento</label>
                      <Field
                        // as="select"
                        // type="text"
                        name="departmentId"
                        id="departmentId"
                        required
                        // value = {values.departmentId}
                        // onChange = {(e)=>refreshMunicipalities(e.target.value)}
                      >
                        {({ field }) => (
                          <select
                            {...field}
                            onChange={(e) =>
                              onChangeSelect(e, field, values, setValues)
                            }
                            selected
                          >
                            <option value="">
                              {" "}
                              Seleccione un departamento{" "}
                            </option>
                            {departmentList &&
                              departmentList.map((item, index) => {
                                return (
                                  <option key={index} value={item.departmentId}>
                                    {item.name}
                                  </option>
                                );
                              })}
                          </select>
                        )}
                      </Field>
                      <span className="form__validation"></span>
                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                      <label htmlFor="municipalityId">Municipio</label>
                      <Field
                        as="select"
                        type="text"
                        name="municipalityId"
                        id="municipalityId"
                        required
                      >
                        <option value="" selected>
                          Selecciona un municipio
                        </option>
                        {municipalitiesList.map((item, index) => {
                          return (
                            <option key={index} value={item.municipalityId}>
                              {item.name}
                            </option>
                          );
                        })}
                      </Field>
                      {errors.municipalities && touched.municipalities && (
                        <span className="form__validation form__validation--error">
                          {errors.municipalities}
                        </span>
                      )}
                    </div>

                    <div className="col-sm-12 ">
                      <label htmlFor="profession">Formación</label>
                      <Field
                        type="text"
                        name="profession"
                        id="profession"
                        required
                      ></Field>
                      {errors.profession && touched.profession && (
                        <span className="form__validation form__validation--error">
                          {errors.profession}
                        </span>
                      )}
                    </div>
                  </section>

                  <section>
                    <label htmlFor="aboutme">Acerca de mi</label>
                    <Field
                      as="textarea"
                      type="text"
                      name="aboutme"
                      id="aboutme"
                      required
                    ></Field>
                    {errors.aboutme && touched.aboutme && (
                      <span className="form__validation form__validation--error">
                        {errors.aboutme}
                      </span>
                    )}
                  </section>

                  <section>
                    <button
                      disabled={isSubmitting}
                      type="submit"
                      className="btn btn--gradient btn__icon btn__icon--door"
                    >
                      Guardar
                    </button>
                  </section>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
}
